import config from '../../config';
import {
  FetchJackpotsV2DataParams,
  JackpotsV2ResponseType,
} from '../../types/jackpotTypes';
import { fetchData } from '../utils/fetch';

export const fetchJackpotsV2 = async ({
  currency,
  gamesJackpotCodes,
  provider,
}: FetchJackpotsV2DataParams) => {
  try {
    const res = await fetchData<JackpotsV2ResponseType>({
      url: `${config.urls.bffBaseUrl}/jackpots/v2/${provider}`,
      queryParameters: {
        code: gamesJackpotCodes,
        currency,
      },
    });

    return res;
  } catch (err) {
    console.error(
      `There was a problem while fetching JackpotsV2 data. ${config.urls.bffBaseUrl}/jackpots/v2/${provider}`
    );
    console.error(err);
    return {};
  }
};
